import React from 'react';
export function UniqueMechanism() {
  return <section className="mb-12" data-id="element-305">
      <h2 className="text-[24px] font-bold text-[#1a1a1a] mb-6 font-serif" data-id="element-306">
        The Three-Phase Approach
      </h2>

      <div className="prose prose-lg font-serif text-[#1a1a1a]" data-id="element-307">
        <p className="mb-6 text-[18px] leading-relaxed" data-id="element-308">
          The Knee Geometry Method™ works because it doesn't just treat
          symptoms. It addresses the mechanical root cause through three
          distinct phases.
        </p>

        <div className="pl-4 border-l-2 border-[#E5E5E0] space-y-6 my-8" data-id="element-309">
          <div data-id="element-310">
            <span className="text-[10px] font-bold text-[#8B2500] uppercase tracking-wider font-sans block mb-1" data-id="element-311">
              Phase 1
            </span>
            <h3 className="text-[18px] font-bold mb-2" data-id="element-312">
              Reset the Angles (Mobility)
            </h3>
            <p className="text-[16px] text-[#4a4a4a]" data-id="element-313">
              First, we restore basic range of motion so your first steps of the
              day don't feel like rusty hinges.
            </p>
          </div>

          <div data-id="element-314">
            <span className="text-[10px] font-bold text-[#8B2500] uppercase tracking-wider font-sans block mb-1" data-id="element-315">
              Phase 2
            </span>
            <h3 className="text-[18px] font-bold mb-2" data-id="element-316">
              Lock in Stability (Safe Strength)
            </h3>
            <p className="text-[16px] text-[#4a4a4a]" data-id="element-317">
              Next, we build specific strength around the joint so your knee
              stops feeling wobbly or untrustworthy on stairs.
            </p>
          </div>

          <div data-id="element-318">
            <span className="text-[10px] font-bold text-[#8B2500] uppercase tracking-wider font-sans block mb-1" data-id="element-319">
              Phase 3
            </span>
            <h3 className="text-[18px] font-bold mb-2" data-id="element-320">
              Train the Walk (Balance + Gait)
            </h3>
            <p className="text-[16px] text-[#4a4a4a]" data-id="element-321">
              Finally, we retrain your nervous system to trust your leg again,
              improving balance and gait mechanics.
            </p>
          </div>
        </div>

        <aside className="bg-[#F5F5F0] p-6 rounded-sm my-8 border border-[#E5E5E0]" data-id="element-322">
          <p className="text-[18px] italic font-serif text-[#1a1a1a] text-center" data-id="element-323">
            "Most knee problems that limit walking aren't motivation problems.
            They're{' '}
            <span className="text-[#8B2500] font-semibold not-italic" data-id="element-324">
              geometry problems
            </span>
            ."
          </p>
        </aside>
      </div>
    </section>;
}